import React from "react";
import { TextField, TextFieldProps, styled, alpha } from "@mui/material";

// Create a styled TextField component
const StyledTextFieldRoot = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: 12,
    backgroundColor:
      theme.palette.mode === "dark"
        ? alpha(theme.palette.background.paper, 0.6)
        : alpha(theme.palette.primary.light, 0.04),
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    backdropFilter: "blur(10px)",
    "& fieldset": {
      borderWidth: "1.5px",
      borderColor:
        theme.palette.mode === "dark"
          ? alpha(theme.palette.primary.main, 0.2)
          : alpha(theme.palette.primary.main, 0.15),
      transition: "border-color 0.3s ease, box-shadow 0.3s ease",
    },
    "&:hover fieldset": {
      borderColor: alpha(theme.palette.primary.main, 0.4),
      borderWidth: "1.5px",
    },
    "&.Mui-focused": {
      backgroundColor:
        theme.palette.mode === "dark"
          ? alpha(theme.palette.background.paper, 0.8)
          : "rgba(255, 255, 255, 1)",
      boxShadow: `0 0 0 3px ${alpha(theme.palette.primary.main, 0.1)}`,
      "& fieldset": {
        borderWidth: "2px",
        borderColor: `${theme.palette.primary.main} !important`,
      },
    },
  },
  "& .MuiInputLabel-outlined": {
    fontSize: "0.95rem",
    fontWeight: 600,
    transition: "color 0.3s ease",
    color: theme.palette.text.secondary,
    "&.Mui-focused": {
      color: theme.palette.primary.main,
      fontWeight: 600,
    },
  },
  "& .MuiOutlinedInput-input": {
    padding: "14px 16px",
    fontSize: "1rem",
    fontWeight: 500,
    transition: "all 0.2s ease",
    "&::placeholder": {
      opacity: 0.6,
      color: theme.palette.text.secondary,
    },
  },
  "& .MuiFormHelperText-root": {
    fontSize: "0.85rem",
    marginTop: "6px",
    transition: "color 0.3s ease",
    "&.Mui-error": {
      color: theme.palette.error.main,
    },
  },
}));

const StyledTextField: React.FC<TextFieldProps> = (props) => {
  return <StyledTextFieldRoot {...props} />;
};

export default StyledTextField;
